import { Box, Inline } from 'braid-design-system';

import {
  COLUMN_WIDTH_CANDIDATE_MATCHES,
  COLUMN_WIDTH_CANDIDATES,
  COLUMN_WIDTH_CTA,
  COLUMN_WIDTH_PERFORMANCE,
  COLUMN_WIDTH_STATUS,
  OVERFLOW_MENU_ICON_WIDTH,
} from 'src/App/Components/RecentJobs/Constants';
import { useAccountContext } from 'src/modules/ApiClient';
import { isDraftJobItem } from 'src/utils/job';

import {
  JobActions,
  JobOverflowMenu,
  type JobFieldProps,
  JobStatus,
  JobNumOfCandidates,
  JobTalentSearch,
  JobTitleAndLocation,
} from './JobItemComponents';
import { JobPerformance } from './JobPerformance/JobPerformance';
import { TableCell } from './TableCell';

import * as styles from './JobsList.css';

interface Props extends JobFieldProps {}

const JobItem = ({ job, listPosition }: Props) => {
  const { data: accountContext } = useAccountContext();

  if (!accountContext) {
    return null;
  }

  const permissions = accountContext.currentAdvertiser.permissionOptions;

  const isDraft = isDraftJobItem(job);

  let status;
  let daysRemaining;

  if (!isDraft) {
    status = job.status;
    daysRemaining = job.daysRemaining;
  }

  return (
    <tr>
      <TableCell
        maxWidth={COLUMN_WIDTH_STATUS}
        minWidth={COLUMN_WIDTH_STATUS}
        paddingLeft="medium"
        width={COLUMN_WIDTH_STATUS}
      >
        <JobStatus
          jobId={job.id}
          isDraft={isDraft}
          status={status}
          daysRemaining={daysRemaining}
        />
      </TableCell>

      <TableCell minWidth={80} maxWidth={250}>
        <JobTitleAndLocation
          job={job}
          listPosition={listPosition}
          maxLines={1}
        />
      </TableCell>

      <TableCell
        maxWidth={COLUMN_WIDTH_CANDIDATES}
        minWidth={COLUMN_WIDTH_CANDIDATES}
        width={COLUMN_WIDTH_CANDIDATES}
      >
        <JobNumOfCandidates job={job} listPosition={listPosition} />
      </TableCell>

      <TableCell
        maxWidth={COLUMN_WIDTH_CANDIDATE_MATCHES}
        minWidth={COLUMN_WIDTH_CANDIDATE_MATCHES}
        width={COLUMN_WIDTH_CANDIDATE_MATCHES}
      >
        <JobTalentSearch job={job} listPosition={listPosition} />
      </TableCell>

      <TableCell
        width={COLUMN_WIDTH_PERFORMANCE}
        minWidth={COLUMN_WIDTH_PERFORMANCE}
        maxWidth={COLUMN_WIDTH_PERFORMANCE}
      >
        <JobPerformance job={job} />
      </TableCell>

      <TableCell
        maxWidth={COLUMN_WIDTH_CTA}
        minWidth={COLUMN_WIDTH_CTA}
        paddingRight="medium"
        width={COLUMN_WIDTH_CTA}
      >
        <Inline alignY="center" align="right" space="small">
          <Box className={styles.jobActionCta}>
            <JobActions
              job={job}
              listPosition={listPosition}
              permissions={permissions}
            />
          </Box>

          <Box style={{ minWidth: OVERFLOW_MENU_ICON_WIDTH }}>
            {!isDraft && (
              <JobOverflowMenu
                job={job}
                listPosition={listPosition}
                permissions={permissions}
              />
            )}
          </Box>
        </Inline>
      </TableCell>
    </tr>
  );
};

export default JobItem;
